<template>
    <div id="home-container">
        <div id="pricesNotLatestWarningMessage" ref="pricesNotLatestWarningMessage" v-show="pricesWarning">Some of the EOD prices from the last trading day are not available. The system is pulling the most recent available EOD prices instead.</div>
        <div class="form-row form-row-first">
            <div class="col-md-2">
                <myClients></myClients>
            </div>
            <div class="col-md-2">
                <gasData></gasData>
            </div>
            <div class="col-md-2">
                <contractData></contractData>
            </div>
            <div class="col-md-6 col-md-6-banner">
                <div>
                    <div class="col-md-12">
                        <triggers></triggers>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row form-row-second">
            <div class="col-md-6" ref="regmap">
                <h6>Power & Gas</h6>
                <homeRegionalMap></homeRegionalMap>
            </div>
            <div class="col-md-6" ref="hbc">
                <h6>Power & Gas Volume</h6>
                <barChart></barChart>
            </div>

        </div>
        <div class="form-row form-row-third">
            <div class="col-md-4">

                <div class="col-md-12 col-md-12-PRates" ref="hpr">
                    <h6>POWER BASELOAD - Front Year</h6>
                    <powerRates></powerRates>
                </div>


            </div>
            <div class="col-md-4">
                <div class="col-md-12 col-md-12-GRates" ref="hgr">
                    <h6>GAS - Front Year</h6>
                    <gasRates></gasRates>

                </div>


            </div>
            <div class="col-md-4">
                <div class="col-md-12 col-md-12-FRates">
                    <h6>FOREX</h6>
                    <fxRates></fxRates>
                </div>
            </div>


        </div>
        <!--<div class="form-row form-row-four">
      <refinitiv></refinitiv>
        </div>-->
        <div class="form-row form-row-four">
        <disclaimer></disclaimer>
          </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import contractData from './homeComponents/contractData.vue'
    import gasData from './homeComponents/gasData.vue'
    import myClients from './homeComponents/clientCard.vue'
    import apis from '@/common/network';
    import urls from '@/common/urls';
    import dates from '@/common/dates';
    import unitConversions from '@/common/unitConversions';
    import triggers from './homeComponents/triggersCard.vue';
    import homeRegionalMap from './homeComponents/homeRegionalMap.vue'
    import fxRates from './homeComponents/fxRates.vue'
    import powerRates from './homeComponents/powerRates.vue'
    import gasRates from './homeComponents/gasRates.vue'
    //import refinitiv from './homeComponents/refinitiv.vue'
    import { DashboardLayoutPlugin } from "@syncfusion/ej2-vue-layouts";
    import { AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
    import barChart from './homeComponents/homeBarChart.vue'
    import orderGrid from '@/common/orderGridFutureEletricity';
    import orderGridGas from '@/common/orderGridFutureGas';
    import disclaimer from './homeComponents/disclaimer.vue'



    Vue.use(AutoCompletePlugin);
    Vue.use(DashboardLayoutPlugin);

    export default Vue.extend({
        created: function () {
        },
        data() {
            return {
                type: 'Over',
                aspectRatio: 100 / 85,
                cellSpacing: [10, 10],
                closeOnDocumentClick: true,
                trades: [],
                //volumes
                powerVolumeGigs: 0,
                gasVolumeGigs: 0,
                pricesWarning: false,
                // market pricing per day
                mppdDateVal: dates.addDays(new Date(), -7),
                mppdPowerRates: [],
                mppdGasRates: [],
                barChartTmp: function () {
                    return { template: barChart }
                },
                visitor: function () {
                    return { template: triggers }
                },
                fxRatesTmp: function () {
                    return { template: fxRates }
                },
                powerRatesTmp: function () {
                    return { template: powerRates }
                },
                gasRatesTmp: function () {
                    return { template: gasRates }
                },
                regionalMapTmp: function () {
                    return { template: homeRegionalMap }
                },
                //refinitivTmp: function () {
                //    return { template: refinitiv }
                //},
                disclaimerTmp: function () {
                    return { template: disclaimer }
                },
                card1: function (e) {
                    return {
                        template: contractData
                    }
                },
                card2: function (e) {
                    return {
                        template: gasData
                    }
                },
                card3: function (e) {
                    return {
                        template: myClients
                    }
                }
            };
        },
        components: {
            contractData,
            gasData,
            myClients,
            triggers,
            fxRates,
            homeRegionalMap,
            powerRates,
            gasRates,
            barChart,
            //refinitiv
            disclaimer
        },
        mounted() {
            this.fetchVolumesData();
            this.fetchMarketPricingPerDayData();
            this.checkLatestAvailablePrices();
        },
        methods: {
            groupBy(arr, keyFunction) {
                const groups = {};
                arr.forEach(function (el) {
                    const key = keyFunction(el);
                    if (key in groups === false) {
                        groups[key] = [];
                    }
                    groups[key].push(el);
                });
                return groups;
            },
            checkLatestAvailablePrices() {
                apis.protectedApi('utils/LatestPricesStatus').then(v => {
                    if (!v.data.areAllAvailable) {
                        this.pricesWarning = true;
                       
                        this.SetTitleOnWarningLabel(v.data.notAvailbleForyesterdayRics);
                       
                    }
                });
               
            },
            SetTitleOnWarningLabel(text) {
                this.pricesWarning = true;
                this.$refs.pricesNotLatestWarningMessage.setAttribute('title', text);
             
            },
            // if diff is a positive number, it's an increase, otherwise it's a decrease
            calculatePercentageDiff(oldValue, newValue) {
                var diff = newValue - oldValue;
                return (diff / oldValue) * 100;
            },
            fetchVolumesData() {
                apis.protectedApi(`${urls.apiBaseUrl}Volume/User`).then(v => {
                    let homeVolumeData = {};
                    let homeRegionalMap = [];
                    let powerContractIds = [...new Set(v.data.result.filter(obj => obj.base > 0 || obj.peak > 0 || obj.offPeak > 0).map(obj => obj.contractId))];
                    homeVolumeData.powerContractIds = powerContractIds;

                    let gasContractIds = [...new Set(v.data.result.filter(obj => obj.gas > 0).map(obj => obj.contractId))];
                    homeVolumeData.gasContractIds = gasContractIds;

                    let powerVolumes = v.data.result.filter(obj => powerContractIds.includes(obj.contractId));
                    let gasVolumes = v.data.result.filter(obj => gasContractIds.includes(obj.contractId));

                    const powerByCountry = this.groupBy(powerVolumes, pv => pv['stateName']);
                    let powerData = Object.keys(powerByCountry).map(country => {
                        const byContractId = this.groupBy(powerByCountry[country], pbc => pbc.contractId);
                        const sum = powerByCountry[country].reduce((acc, obj) => acc + unitConversions.convert(
                            obj.totalBaseOffPeak,
                            obj.volumeUnitName,
                            'MWh',
                            this.datediff(this.getStartDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year), this.getEndDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year)), false
                        ) / 1000, 0);

                        const sumPeak = powerByCountry[country].reduce((acc, obj) => acc + unitConversions.convert(
                            obj.peak,
                            obj.volumeUnitName,
                            'MWh',
                            dates.getBusinessDatesCount(this.getStartDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year), this.getEndDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year)), true
                        ) / 1000, 0);

                        // TODO: apply unit transformation once the transformation functionality is completed
                        this.powerVolumeGigs += sum + (isNaN(sumPeak) ? 0 : sumPeak);

                        return {
                            name: country.replace(/-/g, " "),
                            country: country.replace(/-/g, " "),
                            numberOfContracts: Object.keys(byContractId).length,
                            value: sum,
                            color: "#A35FA1"
                        }
                    });
                    homeVolumeData.powerVolumeGigs = this.powerVolumeGigs;
                    homeVolumeData.powerData = powerData;

                    const gasByCountry = this.groupBy(gasVolumes, pv => pv['stateName']);
                    let gasData = Object.keys(gasByCountry).map(country => {
                        const byContractId = this.groupBy(gasByCountry[country], pbc => pbc.contractId);
                        const sum = gasByCountry[country].reduce((acc, obj) => acc + unitConversions.convert(
                            obj.gas,
                            obj.volumeUnitName,
                            'MWh',
                            this.datediff(this.getStartDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year), this.getEndDateByTradePeriodSpanIdAndYear(obj.periodSpanId, obj.year))
                        ) / 1000, 0);

                        // TODO: apply unit transformation once the transformation functionality is completed
                        this.gasVolumeGigs += sum;

                        return {
                            name: country.replace(/-/g, " "),
                            country: country.replace(/-/g, " "),
                            numberOfContracts: Object.keys(byContractId).length,
                            value: sum,
                            color: "#4875B4"
                        }
                    });
                    for (const data of powerData) {
                        let powerVolume = data.value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                        let s = {
                            name: data.name,
                            country: data.country,
                            powerContracts: data.numberOfContracts,
                            gasContracts: 0,
                            powerVolume: powerVolume,
                            gasVolume: 0,
                            color: "#4875B4"
                        }
                        homeRegionalMap.push(s);
                    }

                    for (const data of gasData) {

                        var foundValue = homeRegionalMap.find(obj => obj.name === data.name);
                        let gasVolume = data.value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                        if (foundValue) {
                            foundValue.gasContracts = data.numberOfContracts;
                            foundValue.gasVolume = gasVolume;
                        } else {
                            let s = {
                                name: data.name,
                                country: data.country,
                                powerContracts: 0,
                                gasContracts: data.numberOfContracts,
                                powerVolume: 0,
                                gasVolume: gasVolume,
                                color: "#4875B4"
                            }
                            homeRegionalMap.push(s);
                        }
                    }
                    homeVolumeData.gasVolumeGigs = this.gasVolumeGigs;
                    homeVolumeData.gasData = gasData;

                    homeVolumeData.homeRegionalMap = homeRegionalMap
                    this.$store.commit('setHomeVolumeData', homeVolumeData);
                    if (this.$refs.hbc) {
                        this.$refs.hbc.querySelector(".home-bar-chart").ej2_instances[0].series[0].dataSource = homeVolumeData.powerData;
                        this.$refs.hbc.querySelector(".home-bar-chart").ej2_instances[0].series[1].dataSource = homeVolumeData.gasData;
                    }
                    if (this.$refs.regmap) {
                        this.$refs.regmap.querySelector(".home-region-map").ej2_instances[0].layers[0].dataSource = homeVolumeData.homeRegionalMap;
                        this.$refs.regmap.querySelector(".home-region-map").ej2_instances[0].refresh();
                    }
                }).catch(
                    //response => { this.handleError(response); }
                );
            },
            /**
             * Returns the start date as a Date object
             * @param tradePeriodSpanId
             * @param year
             */
            getStartDateByTradePeriodSpanIdAndYear: function (tradePeriodSpanId, year) {
                // Months (January to December) have Ids 1 to 12 respectively.
                // Javascript references the dates starting with 0 (to 11 respectively)
                // Cal trade period have no spanIds, so their value will be set to 0
                // which correctly sets the Cal start date to January 1st
                return new Date(year, tradePeriodSpanId === 0 ? tradePeriodSpanId : tradePeriodSpanId - 1, 1);
            },
            /**
             * Returns the end date as a Date object
             * @param tradePeriodSpanId
             * @param year
             */
            getEndDateByTradePeriodSpanIdAndYear: function (tradePeriodSpanId, year) {
                // Months (January to December) have Ids 1 to 12 respectively.
                // Javascript references the dates starting with 0 (to 11 respectively).
                // Javascript dates range from 1 to 31. Passing 0 to the constructor will
                // create the last date of the previous month.
                // Cal trade period have no spanIds, so their year value will be increased by 1,
                // which will correctly set the Cal end date to December 31st
                return tradePeriodSpanId === 0 ? new Date(year + 1, tradePeriodSpanId, 0) : new Date(year, tradePeriodSpanId, 0);
            },
            datediff: function (first, second) {
                // Take the difference between the dates and divide by milliseconds per day.
                // Round to nearest whole number to deal with DST.
                return Math.round((second - first) / (1000 * 60 * 60 * 24)) + 1;
            },
            fetchMarketPricingPerDayData() {
                apis.protectedApi(`${urls.apiBaseUrl}MarketPricingPerDay/FromDate?date=${this.mppdDateVal.toISOString().split('T')[0]}`).then(mppd => {
                    let mppdGrouped = this.groupBy(mppd.data.result, mp => mp.ricId);

                    const mppdArray = Object.keys(mppdGrouped).map(ricId => {
                        return {
                            ricId,
                            mppdGroups: mppdGrouped[ricId]
                        }
                    });

                    for (const mppdObj of mppdArray) {
                        if (mppdObj.mppdGroups.length >= 2) {
                            let mppdGroupedByYear = this.groupBy(mppdObj.mppdGroups, mp => mp.year);

                            const mppdGroupedByYearArray = Object.keys(mppdGroupedByYear).map(year => {
                                return {
                                    year,
                                    mppdGroups: mppdGroupedByYear[year]
                                }
                            });

                            for (let mppdGroupedByYearObj of mppdGroupedByYearArray) {
                                if (mppdGroupedByYearObj.mppdGroups.length >= 2) {
                                    // todo: should check for current year and the next year, if available
                                    let oldMppdRate = mppdGroupedByYearObj.mppdGroups[mppdGroupedByYearObj.mppdGroups.length - 2];
                                    let newMppdRate = mppdGroupedByYearObj.mppdGroups[mppdGroupedByYearObj.mppdGroups.length - 1];

                                    let mppdRate = {
                                        id: newMppdRate.ricId,
                                        state: newMppdRate.stateName,
                                        priceAreaName: (newMppdRate.priceAreaName != null && newMppdRate.priceAreaName != "") ? newMppdRate.stateName + " - " + newMppdRate.priceAreaName : newMppdRate.stateName,
                                        product: newMppdRate.productName,
                                        difference: (newMppdRate.price - oldMppdRate.price).toFixed(3),
                                        //newPrice: newMppdRate.price.toFixed(3),
                                        newPrice: newMppdRate.price.toFixed(3) + " " + newMppdRate.currencySymbol + "/" + newMppdRate.tradingUnitName,
                                        percentageDiff: (this.calculatePercentageDiff(oldMppdRate.price, newMppdRate.price)).toFixed(2),
                                        currencySymbol: newMppdRate.currencySymbol,
                                        tradingUnitName: newMppdRate.tradingUnitName
                                    }

                                    if (mppdRate.product === 'Baseload') {
                                        if (!this.mppdPowerRates.some(r => r.id === mppdRate.id)) {
                                            this.mppdPowerRates.push(mppdRate);
                                        }
                                        var orderEletricity = orderGrid.orderGridEletricity(this.mppdPowerRates);
                                        this.mppdPowerRates = orderEletricity;
                                    } else if (mppdRate.product === 'Gas') {
                                        if (!this.mppdGasRates.some(r => r.id === mppdRate.id)) {
                                            this.mppdGasRates.push(mppdRate);
                                        }
                                        var orderGas = orderGridGas.orderGridGas(this.mppdGasRates);
                                        this.mppdGasRates = orderGas;
                                    }
                                }
                            }
                        }
                    }

                    this.$store.commit('setHomePowerRates', this.mppdPowerRates);
                    this.$store.commit('setHomeGasRates', this.mppdGasRates);
                    if (this.$refs.hpr) {

                        this.$refs.hpr.querySelector(".home-power-rates").ej2_instances[0].dataSource = this.mppdPowerRates;
                        this.$refs.hpr.querySelector(".home-power-rates").ej2_instances[0].refresh();
                    }
                    if (this.$refs.hgr) {

                        this.$refs.hgr.querySelector(".home-gas-rates").ej2_instances[0].dataSource = this.mppdGasRates;
                        this.$refs.hgr.querySelector(".home-gas-rates").ej2_instances[0].refresh();
                    }
                }).catch(
                    //response => { this.handleError(response); }
                );
            },
            populateTriggers: function () {
                apis.protectedApi('utils/userTriggers')
                    .then(response => {
                        this.triggers = response.data;
                    }).catch(e => {
                        //if (e.response.data.message) {
                        //    this.showErrorDialog(e.response.data.message);
                        //}
                    });
            }
        }
    });
</script>

<style scoped>
    /*.dashboard-seo .sidebar-content {
        padding: 10px;
        width: calc(100% - 60px);
    }*/

    .dashboard-seo #analysisLayout.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {
        border-bottom: 2px solid #e6e9ed !important;
        padding: 10px;
        height: 35px;
        margin: 0 15px 0 15px;
    }

    .dashboard-seo #analysisLayout.e-dashboardlayout .e-panel-content {
        height: calc(100% - 35px) !important;
        overflow: hidden;
        width: 100%;
    }

    /*.dashboard-seo #sidebar-section {
        padding: 0px !important;
        border: 1px solid rgba(0, 0, 0, 0.12);
    }*/
    @font-face {
        font-family: "e-sb-icons";
        src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format("truetype");
        font-weight: normal;
        font-style: normal;
    }

    [class^="sf-icon-"],
    [class*=" sf-icon-"] {
        font-family: "e-sb-icons" !important;
        speak: none;
        font-size: 55px;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    /* dockbar icon Style */

    .dashboard-seo .filter::before {
        content: "\e72a";
        font-family: "e-sb-icons";
    }

    .dashboard-seo .analyticsChart::before {
        content: "\e722";
        font-family: "e-sb-icons";
    }

    .dashboard-seo .session::before {
        content: "\e735";
        font-family: "e-sb-icons";
    }

    .dashboard-seo .profile::before {
        content: "\e730";
        font-family: "e-sb-icons";
    }

    .dashboard-seo .views::before {
        content: "\e733";
        font-family: "e-sb-icons";
    }

    span.e-input-group.e-control-wrapper.e-ddl {
        left: 12%;
    }

    .dashboard-seo .expand::before {
        content: "\e72d";
        margin-left: 18px;
        font-family: "e-sb-icons";
        position: absolute;
        top: 12%;
    }

    #right-sidebar {
        display: none;
    }

    .dashboard-seo .e-dock.e-close span.e-text {
        display: none;
    }

    .dashboard-seo .e-dock.e-open span.e-text {
        display: inline-block;
    }

    .dashboard-seo span.e-icons {
        line-height: 2;
    }

    .dashboard-seo .e-open .e-icons {
        margin-right: 16px;
    }


    .dashboard-seo .card-content.text {
        font-size: 15px;
        text-align: right;
        color: #66696b;
    }

    .dashboard-seo .card {
        margin-right: 5%;
        margin-top: 10%;
    }

    .dashboard-seo .card-content.number {
        font-size: 16px;
        text-align: right;
        padding-top: 10px;
    }

    .dashboard-seo .markerTemplate {
        font-size: 12px;
        color: white;
        text-shadow: 0px 1px 1px black;
        font-weight: 500;
    }

    .dashboard-seo .e-dock {
        padding-top: 8px;
    }

    .dashboard-seo .card .e-icons {
        position: absolute;
        top: 20%;
        left: 12%;
        width: 60px;
        height: 60px;
        text-align: center;
        border: 1px solid;
        line-height: 60px;
        color: #25c3cb;
        background: #eef5f7;
        border-radius: 60px;
    }

    .dashboard-seo .dashboardParent {
        width: 100%;
    }

    .dashboard-seo .chart-content, .dashboard-seo .map-content, .dashboard-seo .maps-content {
        height: 100%;
        width: 100%;
    }

    /* styles for highcontrast theme */

    body.highcontrast .dashboard-seo #sidebar-section {
        border: 1px solid #969696;
    }

    body.highcontrast .dashboard-seo #analysisLayout.e-dashboardlayout.e-control .e-panel {
        background: #000;
    }

        body.highcontrast .dashboard-seo #analysisLayout.e-dashboardlayout.e-control .e-panel .e-panel-container .e-panel-header {
            color: rgba(255, 255, 255, 0.54);
        }

    .col-md-6-banner{
        padding: 0px 0px 0px 10px;
    }
    .col-md-12-PRates {
        padding: 0px 0px 0px 0px !important;
        margin-top: 15px;
    }
    .col-md-12-GRates {
        padding: 0px 0px 0px 0px !important;
        margin-top: 15px;
    }
    .col-md-12-FRates {
        padding: 0px 0px 0px 0px !important;
        margin-top: 15px;
    }
    .form-row-second {
        padding: 0px 30px 0px 0px;
        /*height: 685px;*/
    }
    .col-md-6-firstChart{
        display: flex;
        padding: 0px;
    }
    .col-md-6-secondChart {
        display: flex;
        padding: 0px;
    }
    .col-md-8-last {
        background-color: white;
        display: flex
    }
    .form-row-third {
        padding: 0px 30px 5px 0px;
    }
    .card nomargin {
        border: 0px solid!important;
    }
    .form-row-first{
        height: 200px;
    }
    .text-center {
        padding-bottom: 23px!important;
    }
    .p-t-first {
        padding-right: 10px;
    }
    .p-t-second {
        padding-top: 25px;
        padding-right: 10px;
    }
    .p-t-third {
        padding-top: 12px;
    }
    #pricesNotLatestWarningMessage {
        color: #f78764;
        background-color: white;
        text-align: center;
        margin-bottom: 10px;
        margin-right: 29px;
        border-radius: 0.25rem;
    }
    .form-row-four {
        padding: 0px 36px 5px 5px;
    }

</style>